import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import layoutReducer from "../reducers/layoutSlice";
import menuReducer from "../reducers/menuSlice";
import userInfoReducer from "../reducers/userSlice";
import spinnerSlice from "../reducers/spinnerSlice";
import modalReducer from "../reducers/modalSlice";
import codeReducer from "../reducers/CodeSlice";
import holidaySlice from "../reducers/holidaySlice";
import rpReducer from "../reducers/rpSlice";
import cpReducer from "../reducers/cpSlice";
import alarmSlice from "../reducers/alarmSlice";
import bzkndSlice from "../reducers/bzkndSlice";
import weatherSlice from "app/reducers/weatherSlice";
import signUpSlice from "../reducers/signUpSlice";
import mgResourceSlice from "../reducers/mgResourceSlice";
import aiChatSlice from "../reducers/aiChatSlice";

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  whitelist: ["userInfo", "holidays"],
};

const rootReducer = combineReducers({
  layout: layoutReducer,
  menus: menuReducer,
  userInfo: userInfoReducer,
  spinner: spinnerSlice,
  modal: modalReducer,
  code: codeReducer,
  signUp: signUpSlice,
  holidays: holidaySlice,
  rp: rpReducer,
  cp: cpReducer,
  messagesAlarm: alarmSlice,
  bzknd: bzkndSlice,
  weather: weatherSlice,
  mgResource: mgResourceSlice,
  aiChat: aiChatSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
export const persistor = persistStore(store);
